import { create } from 'zustand';

type WebModalStore = {
  showNotInterestSubmitModal: boolean;
  setShowNotInterestSubmitModal: (showNotInterestSubmitModal: boolean) => void;
  showFlowGuideModal: boolean;
  setShowFlowGuideModal: (showFlowGuideModal: boolean) => void;
  showSelectPlatformModal: boolean;
  setShowSelectPlatformModal: (showSelectPlatformModal: boolean) => void;
  showContactInformationModal: boolean;
  setShowContactInformationModal: (
    showContactInformationModal: boolean
  ) => void;
  showSelectInvitedOrderModal: boolean;
  setShowSelectInvitedOrderModal: (
    showSelectInvitedOrderModal: boolean
  ) => void;
  showModalJoinSuccess: boolean;
  setShowModalJoinSuccess: (showModalJoinSuccess: boolean) => void;
  showModalMissOut: boolean;
  setShowModalMissOut: (showModalMissOut: boolean) => void;
  showModalAnalysis: boolean;
  setShowModalAnalysis: (showModalAnalysis: boolean) => void;
  showModalSelectInvitedOrderByNoMatch: boolean;
  setShowModalSelectInvitedOrderByNoMatch: (
    showModalSelectInvitedOrderByNoMatch: boolean
  ) => void;
  showModalSelectInvitedOrderByNoMatchType: 'success' | 'noMatch';
  setShowModalSelectInvitedOrderByNoMatchType: (
    showModalSelectInvitedOrderByNoMatchType: 'success' | 'noMatch'
  ) => void;
  //
  showModalShowImage: boolean;
  modalImageUrl: string;
  setShowModalShowImage: (showModalShowImage: boolean, url?: string) => void;
  //
  showModalConfirmDealPrice: boolean;
  setShowModalConfirmDealPrice: (showModalConfirmDealPrice: boolean) => void;
  showModalSubmitInterest: boolean;
  setShowModalSubmitInterest: (showModalSubmitInterest: boolean) => void;
  showModalWithdrawThisCollaboration: boolean;
  setShowModalWithdrawThisCollaboration: (
    showModalWithdrawThisCollaboration: boolean,
    withDrawOrderId: string
  ) => void;
  withDrawOrderId: string;
  setWithDrawOrderId: (withDrawOrderId: string) => void;
  showModalDealWithdrawn: boolean;
  setShowModalDealWithdrawn: (showModalDealWithdrawn: boolean) => void;
  skipScript: boolean;
  setSkipScript: (skipScript: boolean) => void;
  isAgree: boolean;
  setIsAgree: (isAgree: boolean) => void;
  isShowAgreement: boolean;
  setIsShowAgreement: (isShowAgreement: boolean) => void;
  isShowAddressModal: boolean;
  setShowAddressModal: (isShowAddressModal: boolean) => void;
  isShowImModal: boolean;
  setShowImModal: (isShowImModal: boolean) => void;
  imNum: number;
  setImNum: (imNum: number) => void;
  showEducationModal: boolean;
  setEducationModal: (showEducationModal: boolean, educationInfo: any) => void;
  educationInfo: any;
  //
  showModalSetPaymentMethod: boolean;
  setShowModalSetPaymentMethod: (showModalSetPaymentMethod: boolean) => void;
  showAuthorizationCode: boolean;
  setShowAuthorizationCode: (showAuthorizationCode: boolean) => void;
  agreeProductShip: boolean;
  setAgreeProductShip: (agreeProductShip: boolean) => void;
  showModalPublishTime: boolean;
  setShowModalPublishTime: (showModalPublishTime: boolean) => void;
};

export const useWebModalStore = create<WebModalStore>()((set) => ({
  showNotInterestSubmitModal: false,
  setShowNotInterestSubmitModal: (showNotInterestSubmitModal: boolean) =>
    set({ showNotInterestSubmitModal }),
  showFlowGuideModal: false,
  setShowFlowGuideModal: (showFlowGuideModal: boolean) =>
    set({ showFlowGuideModal }),
  showSelectPlatformModal: false,
  setShowSelectPlatformModal: (showSelectPlatformModal: boolean) =>
    set({ showSelectPlatformModal }),
  showContactInformationModal: false,
  setShowContactInformationModal: (showContactInformationModal: boolean) =>
    set({ showContactInformationModal }),
  showSelectInvitedOrderModal: false,
  setShowSelectInvitedOrderModal: (showSelectInvitedOrderModal: boolean) =>
    set({ showSelectInvitedOrderModal }),
  showModalJoinSuccess: false,
  setShowModalJoinSuccess: (showModalJoinSuccess: boolean) =>
    set({ showModalJoinSuccess }),
  showModalMissOut: false,
  setShowModalMissOut: (showModalMissOut: boolean) => set({ showModalMissOut }),
  showModalAnalysis: false,
  setShowModalAnalysis: (showModalAnalysis: boolean) =>
    set({ showModalAnalysis }),
  showModalSelectInvitedOrderByNoMatch: false,
  setShowModalSelectInvitedOrderByNoMatch: (
    showModalSelectInvitedOrderByNoMatch: boolean
  ) => set({ showModalSelectInvitedOrderByNoMatch }),
  showModalSelectInvitedOrderByNoMatchType: 'noMatch' as const,
  setShowModalSelectInvitedOrderByNoMatchType: (
    showModalSelectInvitedOrderByNoMatchType: 'success' | 'noMatch'
  ) => set({ showModalSelectInvitedOrderByNoMatchType }),
  showModalConfirmDealPrice: false,
  setShowModalConfirmDealPrice: (showModalConfirmDealPrice: boolean) =>
    set({ showModalConfirmDealPrice }),
  showModalSubmitInterest: false,
  setShowModalSubmitInterest: (showModalSubmitInterest: boolean) =>
    set({ showModalSubmitInterest }),
  // 撤回申请弹窗
  showModalWithdrawThisCollaboration: false,
  setShowModalWithdrawThisCollaboration: (
    showModalWithdrawThisCollaboration: boolean,
    withDrawOrderId: string
  ) => {
    if (showModalWithdrawThisCollaboration) {
      set({ showModalWithdrawThisCollaboration, withDrawOrderId });
    } else {
      set({ showModalWithdrawThisCollaboration: false, withDrawOrderId: '' });
    }
  },
  withDrawOrderId: '',
  setWithDrawOrderId: (withDrawOrderId: string) => set({ withDrawOrderId }),
  showModalDealWithdrawn: false,
  setShowModalDealWithdrawn: (showModalDealWithdrawn: boolean) =>
    set({ showModalDealWithdrawn }),
  //
  //
  showModalShowImage: false,
  modalImageUrl: '',
  setShowModalShowImage: (showModalShowImage: boolean, url?: string) =>
    set({ showModalShowImage, modalImageUrl: url }),
  //
  skipScript: false,
  setSkipScript: (skipScript: boolean) => set({ skipScript }),
  isAgree: false,
  setIsAgree: (isAgree: boolean) => set({ isAgree }),
  isShowAgreement: false,
  setIsShowAgreement: (isShowAgreement: boolean) => set({ isShowAgreement }),
  isShowAddressModal: false,
  setShowAddressModal: (isShowAddressModal: boolean) =>
    set({ isShowAddressModal }),
  isShowImModal: false,
  setShowImModal: (isShowImModal: boolean) => set({ isShowImModal }),
  // imNum
  imNum: 0,
  setImNum: (imNum: number) => set({ imNum }),
  showEducationModal: false,
  setEducationModal: (showEducationModal: boolean, educationInfo: any) =>
    set({ showEducationModal, educationInfo }),
  educationInfo: {},
  //
  showModalSetPaymentMethod: false,
  setShowModalSetPaymentMethod: (showModalSetPaymentMethod: boolean) =>
    set({ showModalSetPaymentMethod }),
  showAuthorizationCode: false,
  setShowAuthorizationCode: (showAuthorizationCode: boolean) =>
    set({ showAuthorizationCode }),
  agreeProductShip: false,
  setAgreeProductShip: (agreeProductShip: boolean) => set({ agreeProductShip }),
  showModalPublishTime: false,
  setShowModalPublishTime: (showModalPublishTime: boolean) =>
    set({ showModalPublishTime })
}));
